import { render, staticRenderFns } from "./LearningPathOverview.vue?vue&type=template&id=145af9dc&scoped=true&"
import script from "./LearningPathOverview.vue?vue&type=script&lang=ts&"
export * from "./LearningPathOverview.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPathOverview.vue?vue&type=style&index=0&id=145af9dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145af9dc",
  null
  
)

export default component.exports